/**
 *
 * TeamList
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
/* eslint-disable */
class TeamList extends React.Component {
  render() {
    const { title, list, view_leader } = this.props
    return (
      <div className="TeamListComponent">
        <div className="TeamListComponent-header">
          <div className="TeamListComponent-header-title">{title}</div>
        </div>
        <div className="TeamListComponent-body">
          {list.map((e, i) => {
            const iconGroup = (
              <svg
                width="12"
                height="12"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.03457 2.23661C6.49694 2.52651 6.82117 3.01709 6.8802 3.58654C7.06876 3.67465 7.27805 3.72531 7.49994 3.72531C8.31 3.72531 8.96655 3.06876 8.96655 2.25882C8.96655 1.44876 8.31 0.792206 7.49994 0.792206C6.69762 0.792455 6.0468 1.43728 6.03457 2.23661ZM5.07376 5.23948C5.88381 5.23948 6.54037 4.5828 6.54037 3.77286C6.54037 2.96293 5.88369 2.30637 5.07376 2.30637C4.26382 2.30637 3.60689 2.96305 3.60689 3.77299C3.60689 4.58292 4.26382 5.23948 5.07376 5.23948ZM5.69587 5.33944H4.45139C3.41595 5.33944 2.57357 6.18195 2.57357 7.21739V8.73929L2.57744 8.76313L2.68227 8.79595C3.67041 9.1047 4.52889 9.20766 5.23549 9.20766C6.61562 9.20766 7.41558 8.81417 7.46487 8.78909L7.56284 8.73954H7.57332V7.21739C7.57369 6.18195 6.73131 5.33944 5.69587 5.33944ZM8.1223 3.8254H6.88743C6.87408 4.31947 6.66317 4.76438 6.32959 5.08436C7.24997 5.35804 7.92338 6.21152 7.92338 7.21964V7.68862C9.14264 7.64395 9.84525 7.29838 9.89155 7.27517L9.98952 7.2255H10V5.7031C10 4.66778 9.15762 3.8254 8.1223 3.8254ZM2.50031 3.72556C2.78722 3.72556 3.05416 3.64183 3.28029 3.49918C3.35218 3.03032 3.60352 2.62061 3.96256 2.34156C3.96406 2.31411 3.96668 2.2869 3.96668 2.2592C3.96668 1.44914 3.31 0.79258 2.50031 0.79258C1.69013 0.79258 1.0337 1.44914 1.0337 2.2592C1.0337 3.06888 1.69013 3.72556 2.50031 3.72556ZM3.81742 5.08436C3.48546 4.766 3.2753 4.32347 3.25995 3.83239C3.21415 3.82902 3.16885 3.8254 3.12218 3.8254H1.87782C0.842381 3.8254 0 4.66778 0 5.7031V7.22525L0.00386871 7.24871L0.108698 7.28179C0.90141 7.52926 1.60889 7.64332 2.22339 7.67926V7.21964C2.22364 6.21152 2.89679 5.35829 3.81742 5.08436Z"
                  fill="#C8C8C8"
                />
              </svg>
            )

            return (
              <div className="TeamListComponent-body-row" key={i}>
                <div className="TeamListComponent-body-row-name">
                  {e.segment_name}{" "}
                  {view_leader
                    ? e.leaders && <span>- {e.leaders}</span>
                    : e.employees && <span>- {e.employees}</span>}{" "}
                  {iconGroup}{" "}
                </div>
                <div
                  className="TeamListComponent-body-row-value"
                  style={{ backgroundColor: e.color }}>
                  {e.value_visible}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

TeamList.propTypes = {}

export default TeamList
